import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { first } from "rxjs/operators";
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";
import { SelectionModel } from "@angular/cdk/collections";

import { AlertService, ShowroomService } from "../../_services";

@Component({ templateUrl: "showroom.list.html" })
export class ShowroomList implements OnInit, OnDestroy {
  heading = "Showroom";
  subheading = "";
  icon = "fa fa-folder-o icon-gradient bg-happy-itmeo";
  link = "/showroom/add";
  showrooms: [];
  dataSource: MatTableDataSource<any[]>;
  search_key = "";
  pageSizeOptions = null;
  displayedColumns = ["s_no", "showroom_name", "status", "actions"];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(",").map(str => +str);
  }

  constructor(
    private showroomServices: ShowroomService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.loadAllShowrooms();
  }

  ngOnDestroy() {}

  clearFilters() {
    this.dataSource.filter = "";
    this.search_key = "";
  }

  private loadAllShowrooms() {
    this.showroomServices
      .getAll()
      .pipe(first())
      .subscribe((showrooms: any) => {
        if (showrooms.status == "ok") {
          this.dataSource = new MatTableDataSource(showrooms.result_set);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });
  }

  deleteShowroom(id: number) {
    this.alertService.delete().then(data => {
      if (data) {
        this.showroomServices
          .delete(id)
          .pipe(first())
          .subscribe((data: any) => {
            if (data.status == "ok") {
              this.alertService.success(data.message, true);
              this.loadAllShowrooms();
            } else {
              this.alertService.error(data.message, true);
            }
          });
      }
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
